import axios from "axios";
import { ProposedLinkInfo, ProposedLinkInfoRecords } from "components/curb/map/deckgl/interfaces";
import { put, takeLatest } from "redux-saga/effects";
import { decrypt } from "Utilities/decryption";
import { proposedLinksReceived, setProposedLinkInfo } from "../../actions/regulation/proposedLinks";
import {
    GetProposedLinksAction,
    GET_PROPOSED_LINKS,
    GET_PROPOSED_LINK_INFO,
    ProposedLinksReceivedAction,
    SetProposedLinkInfoAction
} from "../../actions/regulation/proposedLinks/types";
import { showError } from "../../components/commonUtilities";
import { GeneratorYieldType } from "../../interfaces/ActionReducer/GetMethod/GetResponse";

function* getProposedLinks(
    action: GetProposedLinksAction
): Generator<
    | Promise<ProposedLinksReceivedAction>
    | GeneratorYieldType<ProposedLinksReceivedAction["payload"]>,
    void,
    ProposedLinksReceivedAction["payload"]
> {
    try {
        const json = yield axios
            .get("/api/alllinks/GetProposedLinksInBox/", { params: action.payload.params })
            .then((response) => response.data)
            .then((response) => decrypt(response));

        yield put(proposedLinksReceived({ proposedLinks: json }));
    } catch (error) {
        showError(error);
    }
}

export function* getRegulationLinksSaga() {
    yield takeLatest(GET_PROPOSED_LINKS, getProposedLinks);
}

function* getProposedLinkInfo(
    action: GetProposedLinksAction
): Generator<
    | Promise<SetProposedLinkInfoAction["payload"]>
    | GeneratorYieldType<SetProposedLinkInfoAction["payload"]>,
    void,
    SetProposedLinkInfoAction["payload"]["proposedLinkInfo"]
> {
    try {
        const json = yield axios
            .get(
                `/api/proposed_link/?proposed_regulation__scenario=${action.payload.params}&proposed_regulation__is_published=false&limit=10000&fields=id,geometry,parent_link__id,proposed_regulation__id,proposed_regulation__regulationId,bl_street_name,proposed_parent_link,proposed_regulation__sub_activity__color`
            )
            .then((response) => {
                return response.data.results.map((linkInfo: ProposedLinkInfoRecords) => {
                    return {
                        ...linkInfo,
                        isSelected: true
                    };
                });
            });
        const mappedJson: {
            [custom_link_id: string]: ProposedLinkInfoRecords[0];
        } = json.reduce((prev, curr) => {
            return {
                ...prev,
                [curr.id]: curr
            };
        }, {});

        const ids = json.map((val) => val.id);
        if (ids.length) {
            yield axios
                .get(
                    `api/proposedregulationlinks/?regulation__scenario__id=${
                        action.payload.params
                    }&custom_link__id__in=${ids.join(
                        ","
                    )}&regulation__is_published=false&fields=custom_link_id,regulation__sub_activity__color`
                )
                .then((response) => {
                    return response.data.results.forEach(
                        (linkInfo: {
                            custom_link_id: number;
                            regulation: { sub_activity: { color: string } };
                        }) => {
                            mappedJson[
                                linkInfo["custom_link_id"]
                            ].proposed_regulation.sub_activity.color =
                                linkInfo.regulation.sub_activity.color;
                        }
                    );
                });
        }
        yield put(setProposedLinkInfo({ proposedLinkInfo: Object.values(mappedJson) }));
    } catch (error) {
        showError(error);
    }
}

export function* getProposedLinkInfoSaga() {
    yield takeLatest(GET_PROPOSED_LINK_INFO, getProposedLinkInfo);
}
